'use strict';

angular.module('chatEngine.reporting', ['chatEngine.services'])

.controller('ReportingCtrl', ['$scope', '$http', '$window', 'mixpanelService',
function($scope, $http, $window, mixpanelService) {

    var intToMonth = {
        1: 'Jan',
        2: 'Feb',
        3: 'Mar',
        4: 'Apr',
        5: 'May',
        6: 'Jun',
        7: 'Jul',
        8: 'Aug',
        9: 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
    };

    var STAR_COUNT = 5;

    $scope.loadedGraph = false;
    $scope.loadingError = false;
    // charts
    $http.get('/api/metrics/timeseries').success(function(data) {
        var $el = angular.element('.timeseries .graph');
        var legend = {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical',
            itemMarginBottom: 10,
            itemStyle: {
                fontWeight: 'normal'
            }
        };
        if($el.width() < 500) {
            legend.align = 'center';
            legend.verticalAlign = 'bottom';
        }
        $el.highcharts({
            chart: {
                type: 'line'
            },
            credits: {
                enabled: false
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {
                title: {
                    text: 'Number of Events'
                },
                min: 0,
                gridLineWidth: 1
            },
            series: data,
            legend: legend
        });
        $scope.loadedGraph = true;
    }).error(function() {
        $scope.loadedGraph = true;
        $scope.loadingError = true;
    });

    // subscriber data
    $http.get('/api/metrics/dashboard').success(function(data) {
        $scope.chatters = data.num_sub;
    });

    $scope.downloadGraphData = function() {
        mixpanelService.track('Download Graph Data click');
        $window.open('/api/metrics/timeseries_csv', '_blank');
    };

    $scope.downloadFeedbackData = function(month) {
        if (!$scope.isMonthReportAvailable(month)) {
            return;
        }
        mixpanelService.track('Download Feedback Data click');
        $window.open('/v1/rating/download?month=' + month.monthInt + '&year=' + month.year, '_blank');
    };

    $scope.availableMonths = [];

    $scope.isMonthReportAvailable = function(month) {
        if (!$scope.availableMonths) {
            return false;
        }

        var yearMonth = month.year + '-' + month.monthInt;
        for (var i = 0; i < $scope.availableMonths.length; i++) {
            if (yearMonth === $scope.availableMonths[i]) {
                return true;
            }
        }
        return false;
    };

    var months = [];

    for (var i = -11; i < 1; i++) {
        var current_date = new Date();
        current_date.setMonth(current_date.getMonth() + i);

        months.push({
            year: current_date.getFullYear(),
            monthInt: current_date.getMonth() + 1,
            monthStr: intToMonth[current_date.getMonth() + 1]
        });
    }

    $scope.months = months;

    $scope.getNumber = function(num) {
        return new Array(num);
    };

    $scope.loadingRatings = true;
    $http.get('/v1/rating/report')
    .success(function(data) {
        parseRatingReportData(data);
    })
    .error(function(data, status) {
        if (status === 404) {
            parseRatingReportData({});
        } else {
            $scope.ratingLoadingError = true;
        }
    })
    .finally(function() {
        $scope.loadingRatings = false;
    });

    function parseRatingReportData(data) {
        var progressRatings = [];
        for (var y = 0; y < STAR_COUNT; y++) {
            progressRatings.push({
                level: y + 1,
                count: 0,
                progress: 0
            });
        }

        $scope.overallRating = 0;
        $scope.totalRatings = 0;
        $scope.progressRatings = progressRatings;

        if (!data || Object.keys(data).length === 0) {
            return;
        }

        $scope.availableMonths = data.monthly_ratings;

        var ratingsCount = [
            data.one_star_ratings_count,
            data.two_star_ratings_count,
            data.three_star_ratings_count,
            data.four_star_ratings_count,
            data.five_star_ratings_count
        ];

        $scope.totalRatings = ratingsCount.reduce(function(a, b) {return a + b;}, 0);

        var totalValue = 0;
        for (var i = 0; i < STAR_COUNT; i++) {
            totalValue += ratingsCount[i] * (i + 1);

            progressRatings[i].count = ratingsCount[i];
            if ($scope.totalRatings > 0) {
                progressRatings[i].progress = Math.floor((ratingsCount[i] / $scope.totalRatings) * 100);
            }
        }
        if ($scope.totalRatings > 0) {
            $scope.overallRating = totalValue / $scope.totalRatings;
        }

        $scope.overallRatingFloored = Math.floor($scope.overallRating);
    }
}]);
